import { render, staticRenderFns } from "./SoftPhone.vue?vue&type=template&id=3198607b&scoped=true&"
import script from "./SoftPhone.vue?vue&type=script&lang=js&"
export * from "./SoftPhone.vue?vue&type=script&lang=js&"
import style0 from "./SoftPhone.vue?vue&type=style&index=0&id=3198607b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3198607b",
  null
  
)

export default component.exports